/*
 * Project: forca
 * File Created: Wednesday, 8th December 2021 11:26:22 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import QuoteBlock from './quoteBlock.component';

export const QuoteBlockContainer = (props: any) => {
	const containerProps = () => {
		const { currentBlock = null } = props;

		if (!currentBlock) {
			return props;
		}

		const {
			currentBlock: {
				quote,
				cite,
				author,
				elementMargin
			}
		} = props;

		return {
			quote,
			cite,
			author,
			elementMargin
		};
	};

	return (
		<QuoteBlock
			{ ...containerProps() }
		/>
	);
};

export default QuoteBlockContainer;